import DependencyType from 'components/Tables/DataManagement/Article8/DependencyType';
import EntityRole from 'components/Tables/DataManagement/Article8/EntityRole';
import ExposureCategory from 'components/Tables/DataManagement/Article8/ExposureCategory';
import ICTRisk from 'components/Tables/DataManagement/Article8/ICTRisk';
import ICTRiskLevel from 'components/Tables/DataManagement/Article8/ICTRiskLevel';
import ICTRiskSource from 'components/Tables/DataManagement/Article8/ICTRiskSource';
import Responsibility from 'components/Tables/DataManagement/Article8/Responsibility';
import RiskExposure from 'components/Tables/DataManagement/Article8/RiskExposure';
import RoleType from 'components/Tables/DataManagement/Article8/RoleType';
import ICTSystemCriticality from 'components/Tables/DataManagement/Article8/ICTSystemCriticality';
import Report99 from 'components/Tables/DataManagement/Report99/Report99';
import { STEP_KEYS } from 'store/ducks/Global/types';

export const getStepsMainRisk = (t: (key: string) => string) => [
  {
    key: STEP_KEYS.ICT_RISK,
    title: t('ARTICLE_8.ICT_RISK'),
    content: <ICTRisk />,
  },
  {
    key: STEP_KEYS.ENTITY_ROLE,
    title: t('ARTICLE_8.ENTITY_ROLE'),
    content: <EntityRole />,
  },
  {
    key: STEP_KEYS.RESPONSIBILITIES,
    title: t('ARTICLE_8.RESPONSIBILITIES'),
    content: <Responsibility />,
  },
];

export const getStepsRiskExposure = (t: (key: string) => string) => [
  {
    key: STEP_KEYS.ICT_RISK_EXPOSURE,
    title: t('ARTICLE_8.ICT_RISK_EXPOSURE'),
    content: <RiskExposure />,
  },
];

export const getStepsRoleType = (t: (key: string) => string) => [
  {
    key: STEP_KEYS.ROLE_TYPE,
    title: t('ARTICLE_8.ROLE_TYPE'),
    content: <RoleType />,
  },
  {
    key: STEP_KEYS.ICT_RISK_SOURCE,
    title: t('ARTICLE_8.ICT_RISK_SOURCE'),
    content: <ICTRiskSource />,
  },
  {
    key: STEP_KEYS.ICT_RISK_LEVEL,
    title: t('ARTICLE_8.ICT_RISK_LEVEL'),
    content: <ICTRiskLevel />,
  },
  {
    key: STEP_KEYS.EXPOSURE_CATEGORY,
    title: t('ARTICLE_8.EXPOSURE_CATEGORY'),
    content: <ExposureCategory />,
  },
  {
    key: STEP_KEYS.DEPENDENCY_TYPE,
    title: t('ARTICLE_8.DEPENDENCY_TYPE'),
    content: <DependencyType />,
  },
  {
    key: STEP_KEYS.ICT_SYSTEM_CRITICALITY,
    title: t('ARTICLE_8.ICT_SYSTEM_CRITICALITY'),
    content: <ICTSystemCriticality />,
  },
];

export const getStepsReport99 = (t: (key: string) => string) => [
  {
    key: STEP_KEYS.REPORT99,
    title: t('STEPS.REPORT99'),
    content: <Report99 />,
  },
];
